import {toTimeString} from "../../util/timeutils";
import {Table} from "antd";
import {PaymentStatusWidget} from "../widget/PaymentStatusWidget";

export const InvoicePaymentTable = ({invoice, payments}) => {
    const invoicePayments = payments;

    const columns = [
        {
            title: 'Payment Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (val, record, index) => {
                return `$ ${val}`
            }
        },
        {
            title: 'Recorded by',
            dataIndex: 'username',
            key: 'username'
        },
        {
            title: 'Date',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val, record, index) => {
                return toTimeString(new Date(val));
            }
        },
        {
            title: 'Account',
            dataIndex: 'accountName',
            key: 'accountName'
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
        },
        {
            title: 'Status',
            dataIndex: 'state',
            key: 'state',
            render: (val) => {
                return <PaymentStatusWidget status={val}/>
            }
        }
    ];

    if (invoice === undefined) {
        return <div />
    }

    return <Table dataSource={invoicePayments} columns={columns} pagination={false} />
}